export default __webpack_public_path__ + "static/media/vegan.31fbf160.jpeg";